import React from 'react'

const Divider = () => {
    return (
        <div className="flex items-center mt-12">
            <div className="flex-grow h-[2px] bg-gradient-to-r from-transparent via-amber-600 to-transparent" />
            <svg className="mx-4 w-8 h-8 text-amber-700" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2L15 8H9L12 2ZM12 22L9 16H15L12 22ZM2 12L8 15V9L2 12ZM22 12L16 9V15L22 12Z" />
            </svg>
            <div className="flex-grow h-[2px] bg-gradient-to-r from-transparent via-amber-600 to-transparent" />
        </div>
    )
}

export default Divider